import { render, staticRenderFns } from "./contactsSettings.vue?vue&type=template&id=7819e1e6"
import script from "./contactsSettings.vue?vue&type=script&lang=js"
export * from "./contactsSettings.vue?vue&type=script&lang=js"
import style0 from "./contactsSettings.vue?vue&type=style&index=0&id=7819e1e6&prod&tyle=text%2Fcss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports